'use client';
import { getCookie } from '@/app/actions/cookies';
import { RainbowButton } from '@/components/ui/rainbow-button';
import { siteConfig } from '@/config/site';
import { useAuth } from '@/providers/auth-provider';
import { LanguagesIcon, Loader2Icon } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useTransition } from 'react';

const TranslateButton = ({ url, title }: { url: string; title: string }) => {
  const router = useRouter();
  const { user, triggerLogin } = useAuth();

  const [isPending, startTransition] = useTransition();

  return (
    <RainbowButton
      disabled={isPending}
      className="rounded-full h-12 gap-1"
      onClick={async () => {
        const target = `/translate/reference?url=${encodeURIComponent(url)}&referer=pubmed&title=${title}`;
        const token = await getCookie(siteConfig.tokenName);
        if (!token) {
          triggerLogin &&
            triggerLogin(() => {
              startTransition(() => {
                router.push(target);
              });
            });
        } else {
          startTransition(() => {
            router.push(target);
          });
        }
      }}
    >
      {isPending ? (
        <Loader2Icon className="w-4 h-4 animate-spin" />
      ) : (
        <LanguagesIcon className="w-4 h-4" />
      )}
      {user ? '一键' : '免费'}翻译全文
    </RainbowButton>
  );
};

export default TranslateButton;
